import React from 'react';
import { Button } from '@pushpay/button';
import { ArrowSolidIcon, OrgPlaceholderIcon } from '@pushpay/iconography';
import { clsx, createUseStyles } from '@pushpay/styles';
const useStyles = createUseStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 12px 11px 12px',
    justifyContent: 'space-between',
    boxShadow: '0 -5px 0 0 transparent inset',
    transition: 'box-shadow 150ms',
    [theme.mediaBreakpoint('MOBILE')]: {
      width: '56px'
    },
    '&:hover': {
      backgroundColor: theme.colors['palette-grey-light-300']
    },
    '&:focus-visible': {
      outline: '1px auto',
      outlineColor: theme.colors['product-color'],
      outlineOffset: '-1px'
    }
  },
  panelOpen: {
    boxShadow: `0 -5px 0 0 ${theme.colors['product-color']} inset`
  },
  orgSummaryArrowIcon: {
    transition: 'transform 150ms ease 0s',
    margin: `0 ${theme.SPACING.XSMALL}`
  },
  orgSummary: {
    display: 'flex',
    alignItems: 'center'
  },
  orgLogo: {
    width: '32px',
    height: '32px',
    marginRight: theme.SPACING.SMALL
  },
  orgName: {
    maxWidth: '250px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.mediaBreakpoint('MOBILE')]: {
      marginRight: 0
    }
  }
}));
export const OrgSwitcherSummary = ({
  isPanelOpen,
  onClick,
  isMobile = false,
  singleOrganization,
  currentOrgName,
  currentOrgLogoUrl,
  buttonLabel,
  'data-pp-at-target': targetId
}) => {
  const classes = useStyles(undefined);
  return /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: clsx(classes.root, isPanelOpen && classes.panelOpen),
    onClick: onClick,
    disabled: singleOrganization,
    "aria-label": buttonLabel,
    "data-pp-at-target": `${targetId}-summary`
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.orgSummary
  }, currentOrgLogoUrl ? /*#__PURE__*/React.createElement("img", {
    src: currentOrgLogoUrl,
    className: classes.orgLogo,
    alt: currentOrgName
  }) : /*#__PURE__*/React.createElement(OrgPlaceholderIcon, {
    "data-pp-at-target": `org-switch-org-item-${currentOrgName}`,
    className: classes.orgLogo
  }), !isMobile && /*#__PURE__*/React.createElement("span", {
    className: classes.orgName
  }, currentOrgName)), !isMobile && !singleOrganization && /*#__PURE__*/React.createElement(ArrowSolidIcon, {
    "data-pp-at-target": isPanelOpen ? 'arrow-up-icon' : 'arrow-down-icon',
    mode: isPanelOpen ? 'up' : 'down',
    className: classes.orgSummaryArrowIcon
  }));
};